/***************************************************************************************************/
/*                                 Security                                                        */
/***************************************************************************************************/
// tslint:disable:max-line-length
import {TCITenantAppType} from "./tci-application";
import {
    AbstractTCITenantComponentOptions,
    ITCIOptionType,
    ITCITenantComponentOptions,
    TCITenantSelectorType
} from "./tci-tenant";

export const TCI_SECURITY_TYPE: ITCIOptionType<string> = {
    // SCRIBE_SECURITY: "Security",
    // VPN_SECURITY: "VPN Connections"
};
export type TCI_SECURITY_TYPE = keyof typeof TCI_SECURITY_TYPE | string;

/**
 * class TCITenantEnvToolsMenu
 */
export class TCITenantSecurityOptions extends AbstractTCITenantComponentOptions<TCI_SECURITY_TYPE> implements ITCITenantComponentOptions<TCI_SECURITY_TYPE> {
    // public static TCI_SECURITY_SCRIBE = new TCITenantSecurityOptions(
    //     "Security",
    //     TCITenantSelectorType.TCI_SECURITY_SCRIBE,
    //     1, TCI_SECURITY_TYPE.SCRIBE_SECURITY,
    //     "scribesecurity",
    //     [
    //         TCITenantAppType.scribe
    //     ]);
    // public static TCI_SECURITY_VPN = new TCITenantSecurityOptions(
    //     "VPN Connections",
    //     TCITenantSelectorType.TCI_ENV_TOOLS_VPN_CONNECTIONS,
    //     2,
    //     TCI_SECURITY_TYPE.VPN_SECURITY,
    //     "vpnsecurity",
    //     [
    //         TCITenantAppType.flogo,
    //         TCITenantAppType.bw,
    //         TCITenantAppType.mock,
    //         TCITenantAppType.modeler,
    //         TCITenantAppType.node,
    //         TCITenantAppType.mg,
    //     ]);

    private static allItems = [
        // TCITenantSecurityOptions.TCI_SECURITY_SCRIBE,
        // TCITenantSecurityOptions.TCI_SECURITY_VPN,
    ];

    /**
     * Gets All items
     * @param securityType
     * @return @ITCITenantSecurityOptions[]
     */
    public static getAllItems(securityType?: TCI_SECURITY_TYPE): ITCITenantComponentOptions<TCI_SECURITY_TYPE>[] {
        if (securityType) {
            return TCITenantSecurityOptions.allItems.filter((v) => {
                return v.getOptionType() === securityType;
            });
        }
        return TCITenantSecurityOptions.allItems;
    }

    /**
     * constructor
     * @param securityOption
     * @param componentSelectorType
     * @param position
     * @param toolType
     * @param routeId
     * @param tenantAppTypes
     */
    private constructor(securityOption: string,
                        componentSelectorType: TCITenantSelectorType,
                        position: number, toolType: TCI_SECURITY_TYPE,
                        routeId: string,
                        tenantAppTypes: TCITenantAppType[]) {
        super(securityOption, componentSelectorType, position, toolType, routeId, tenantAppTypes, null);
    }
}
